import SingleOfferTemplate from '../../component/template/SingleOfferTemplate'
import Webview from '../../component/native/visible/Webview'
import Message from '../../Message'
import App from '../../App'
import {report} from '../../../common/decorators'
import {presetOnlyImpression, presetPvUrls} from '../../../common/m_common/mBizReportPreset'
import {
    presetBtAdShowFailed,
    presetBtClose,
    presetBtGpShowFailed,
    presetBtGpShowSuccess,
    presetBtInitSDKVersionEmpty,
    presetBtShow,
    presetBtWebviewTerminate,
} from '../../../common/m_common/mNonBizReportPreset'
import SubplayTemplateView from "../../component/native/visible/SubplayTemplateView";
import Platform from "../../platform";
import * as Tools from "../../../common/tool";

let currentCampaign = {}

export default class Googleplay extends SingleOfferTemplate {
    constructor(props = {}) {
        super(props)
        // 初始化上报所使用的全局campaign信息
        currentCampaign = this.campaign
        //webviewshow时 sdk传递的数据
        this.adShowedData = {}
        // 是否给奖励回调,默认为2，不给奖励回调，1，给奖励，根据unitSetting.vdcmp判断当前播放进度是否达到
        this.convert = 2
        // googleplay加载成功
        this.gpPageHasLoadedSuccess = false
        // googleplay下载按钮加载成功
        this.gpCtaHasLoadedSuccess = false
        // googleplay关闭按钮加载成功
        this.gpCloseBtnHasLoadedSuccess = false
        // 是否已调用关闭广告方法标识
        this.hasClosed = false
        // 检查当前 initData 中的 sdk_info 是否为空，如果为空则显式抛出错误，上报特殊埋点，并直接通知 SDK not ready
        this.checkIfSDKVersionEmpty();
    }

    /**
     * 检查当前 initData 中的 sdk_info 是否为空，如果为空则显式抛出错误，上报特殊埋点，并直接通知 SDK not ready
     */
    checkIfSDKVersionEmpty() {
        let currentSDKVersion = App && App.initData && (App.initData.sdk_info || App.initData.appSetting && App.initData.appSetting.sdk_info) || ''
        if (currentSDKVersion === '') {
            console.error('currentSDKVersion 为空，无法判断当前 SDK 版本，请检查：', currentSDKVersion, App)
            this.initSDKVersionEmptyTimingReport()
            App.failureToShowAD()
        } else {
            console.log('currentSDKVersion 非空，不影响 WindVane 版本判断，检查通过：', currentSDKVersion, App)
        }
    }

    async adShowed(data) {
        super.adShowed()
        this.rvTpl.appendTo(this.container)
        // webviewshow之后返回数据
        this.adShowedData = data
        console.log("this.adShowedData", this.adShowedData)
        this.h5Setting = Tools.getAdStatus({
            ...App.initData,
            adShowTime: App.adShowTime
        })
        // 告诉sdk是否超时，必须在初始化h5setting之后调用，确保拿到是否超时的值，必须在impression埋点之前上报，确保sdk拿到之后进行改变
        this.rvTpl.setInfo({
            reward: this.reward,
            userId: this.adShowedData.param.userId,
            expired: this.h5Setting.expired
        }).then(() => {
            // 展示成功 进行 onlyImpression 节点的相关上报，
            // 注意：以 onlyImpression 为起点的所有业务上报依赖 h5Setting 初始化，所以相关上报需要放在 h5Setting 初始化之后调用
            // 广告展示时，在 h5Setting 初始化之后，进行任何展示逻辑之前：
            this.onlyImpressionTimingReport()
        })
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...this.h5Setting,
            campaign: this.campaign,
            nodeName: "showSuccess",
            adShowTime: this.adShowTime
        })
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign: this.campaign,
            nodeName: "showSuccess",
        })
        // webview 被系统回收时上报 webviewTerminate 埋点，并直接关闭广告
        this.handelWebviewTerminateEventAfterShow();
    }

    // 之后可以考虑抽到更高一级模版中,目前每个子模版都有用
    closeAdWithShowFailedBiz() {
        console.error('当前 campaign 的视频资源没有下载完成或不存在，无法正常展示广告，showfailed')
        // showFailed时机：
        // 单offer,一个视频播放失败或无法播放，
        // 多offer：（多个视频都无法播放或失败），
        // 据产品描述，但凡收到onlyImpression上报就说明展示成功了，就不是showFailed，
        // 需跟康康确认onlyimpression上报是否根据视频播放失败来判断
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...this.h5Setting,
            campaign: this.campaign,
            nodeName: "showFailed",
            adShowTime: this.adShowTime,
            error: {
                code: 12930007,
                msg: "kMTGErrorCodeFailedToShow"
            }
        })
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign: this.campaign,
            nodeName: "showFailed",
        })
        // showfailed 埋点上报
        this.adShowFailedTimingReport()
        // 强制关闭整个广告
        App.closeAd()
    }

    /**
     * webview 被系统回收时上报 webviewTerminate 埋点，并直接关闭广告
     */
    handelWebviewTerminateEventAfterShow() {
        document.addEventListener('onWebviewTerminate', res => {
            this.webviewTerminateTimingReport()
            this.closeAdWithBiz()
        })
    }

    // 判断是否为安卓且 link_type == 2
    checkGpCanCreate() {
        console.log("##this.campaign.link_type", this.campaign.link_type)
        return this.campaign.link_type == 2 && Platform.isAndroid()
    }

    // 初始化Googleplay
    initGp() {
        // 创建谷歌页面底部下载按钮 webview
        this.gpPageBottom = new Webview();
        Webview.getLoadCampaignParams(`${Tools.parseDns()}/ec-bottom/ec-bottom.html`, [this.campaign], this.unit.id, this.unit.setting)
        // Webview.getLoadCampaignParams('http://192.168.4.150:3000/ec-bottom/ec-bottom.html', [this.campaign], this.unit.id, this.unit.setting)
        // Webview.getLoadCampaignParams('http://47.95.208.135/deploy-wp-dev/m/static/ec-bottom/ec-bottom.html', [this.campaign], this.unit.id, this.unit.setting)
            // Webview.getLoadCampaignParams('https://test-hybird.rayjump.com/wangping/ec-bottom/ec-bottom.html', [this.campaign], this.unit.id, this.unit.setting)
            .then(loadParams => {
                this.gpPageBottom.onLoad((data) => {
                    const {result, error} = data
                    console.log("##gpPageBottom onload data", data)
                    if (result == 1) {
                        this.gpCtaHasLoadedSuccess = true
                    } else {
                        console.error('gpPageBottom load failed ', error)
                    }
                })
                this.gpPageBottom.load(loadParams)
            })

        this.gpPageBottom.setBG({
            color: "#fff"
        })
        // 创建关闭按钮webview
        this.endcardCloseBtn = new Webview()
        Webview.getLoadCampaignParams(`${Tools.parseDns()}/ec-closebtn/ec-closebtn.html`, [this.campaign], this.unit.id, this.unit.setting)
        // Webview.getLoadCampaignParams('http://192.168.4.150:3000/ec-closebtn/ec-closebtn.html', [this.campaign], this.unit.id, this.unit.setting)
        // Webview.getLoadCampaignParams('http://47.95.208.135/deploy-wp-dev/m/static/ec-closebtn/ec-closebtn.html', [this.campaign], this.unit.id, this.unit.setting)
            // Webview.getLoadCampaignParams('https://test-hybird.rayjump.com/wangping/ec-closebtn/ec-closebtn.html', [this.campaign], this.unit.id, this.unit.setting)
            .then(loadParams => {
                this.gpPageBottom.onLoad((data) => {
                    const {result, error} = data
                    console.log("##gpCloseBtnHasLoadedSuccess onload data", data)
                    if (result == 1) {
                        this.gpCloseBtnHasLoadedSuccess = true
                    } else {
                        console.error('gpCloseBtnHasLoadedSuccess load failed ', error)
                    }
                })
                console.log('获取到load campaign参数(closeBtn)：', loadParams)
                this.endcardCloseBtn.load(loadParams)
            })
        // 创建 Googleplay webview
        this.gpPage = new Webview()
        // googleplay url
        let googleLinkPre = "https://play.google.com/store/apps/details?id=";
        // googleplay link
        let googleLink = googleLinkPre + this.campaign.package_name;
        // 监听load返回结果
        this.gpPage.onLoad((data) => {
            const {result, error} = data
            console.log("##gpPage onload data", data)
            if (result == 1) {
                this.gpPageHasLoadedSuccess = true
            } else {
                console.error('Google Play load failed ', error)
            }
        })
        // load googleplay
        this.gpPage.load({content: {fileURL: googleLink}})
        this.showGpEndcard()
    }

    initComponents() {
        super.initComponents()
        console.log("##创建type4组件 webview")
        // 创建type4组件 webview
        this.rvTpl = new SubplayTemplateView({
            campaign: this.campaign,
            unitId: this.unit.id,
            unitSetting: this.unit.setting,
            userId: "",
            reward: "",
        });
        this.rvTpl.preload()
        this.rvTpl.onLoad(() => {
            console.log("##this.rvTpl load success")
            this.checkGpCanCreate() && this.initGp()
            console.log("this.checkGpCanCreate()", this.checkGpCanCreate())
        })
        // 由于当视频一打开立刻关掉的时候，sdk给的endcardshow事件会比load成功事件早，
        // this.checkGpCanCreate() && this.initGp()
        // 插入播放模版
        // this.rvTpl.appendTo(this.container)
        // console.log("插入播放模版")
        this.rvTpl.onDismissed((data) => {
            console.log("##监听到关闭整个广告事件")
            if(data.convert){
                if(data.convert === true || data.convert === 1){
                    this.convert = 1
                }else{
                    this.convert = 2
                }
            }
            this.closeAdWithBiz();
        })
        this.rvTpl.onCloseBtnClicked((data) => {
            console.log("##监听到关闭按钮点击事件")
            if(data.convert){
                if(data.convert === true || data.convert === 1){
                    this.convert = 1
                }else{
                    this.convert = 2
                }
            }
            this.closeAdWithBiz();
        })
    }

    bindPageEvent() {
        // Create for endcard close in this tpl
        Message.onSubViewEmitMessage('MTG_TriggerCloseBtn', () => {
            console.log('##收到MTG_TriggerCloseBtn')
            this.closeAdWithBiz();
        })

        Message.onSubViewEmitMessage('onInstallBtnClick', (data) => {
            console.log("##收到onInstallBtnClick")
            console.log("##调用clicked回调方法")
            // 调用回调/扣回调方法
            this.platform.callReactDeveloper({
                ...App.initData,
                ...this.h5Setting,
                campaign: this.campaign,
                nodeName: "clicked",
                adShowTime: this.adShowTime,
            })
        })
        this.rvTpl.onPlayCompleted((data) => {
            console.log("##视频播放完成")
            console.log("##视频播放完成返回data.convert",data.convert)
            if(data.convert){
                if(data.convert === true || data.convert === 1){
                    this.convert = 1
                }else{
                    this.convert = 2
                }
            }
            // 调用回调/扣回调方法
            this.platform.callReactDeveloper({
                ...App.initData,
                ...this.h5Setting,
                campaign: this.campaign,
                nodeName: "playCompleted",
                adShowTime: this.adShowTime,
            })
            // 调用自动load方法
            this.platform.callLoadAds({
                ...App.initData,
                campaign: this.campaign,
                nodeName: "playCompleted",
            })
        })
        this.rvTpl.onPlayFailed(() => {
            console.log("监听到showFailed时机，调用showFailed回调")
            this.closeAdWithShowFailedBiz();
        })
        this.rvTpl.onClicked(() => {
            console.log("##监听到点击事件")
            console.log("##调用clicked回调方法")
            // 调用回调/扣回调方法
            this.platform.callReactDeveloper({
                ...App.initData,
                ...this.h5Setting,
                campaign: this.campaign,
                nodeName: "clicked",
                adShowTime: this.adShowTime,
            })
        })
    }

    /**
     * 在关闭广告前执行 "开发者奖励回调(callReactDeveloper)、关闭回调（调用closeAd）、自动 load、close 埋点上报" 等逻辑
     */
    closeAdWithBiz() {
        if (!this.hasClosed) {
            this.hasClosed = true
            // 广告关闭
            console.log("##关闭广告")
            // 调用关闭广告回调
            this.closeAdCallReact()
            this.adCloseTimingReport() // 关闭广告上报
            App.closeAd() // 关闭回调，ios需要，安卓不需要（奖励回调发出后，安卓会调用closeAd）
        }
    }

    closeAdCallReact(){
        // 调用回调/扣回调方法
        console.log("##关闭广告回调")
        // 由于仅在安卓投，所以暂不加判断兼容
        // if (this.convert == 2 && this.platform.isIOS() && this.platform.checkVersionBetweenOpenInterval("5.9.0", "6.3.0")) {
        //     this.convert = 0;
        // }
        console.log("##回调传入convert",this.convert)
        this.platform.callReactDeveloper({
            ...App.initData,
            ...this.h5Setting,
            campaign: this.campaign,
            nodeName: "dismissed",
            adShowTime: this.adShowTime,
            convert: this.convert,
            reward: this.reward,
        })
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign: this.campaign,
            nodeName: "dismissed",
        })
    }

    showGpEndcard() {
        console.log("##showGpEndcard")
        // 监听endcardShowSuccess
        this.rvTpl.onEndcardShowSuccess((data) => {
            // 展示条件：googleplay页面加载成功，link_type=2,安卓
            console.log("##监听到endcardshowSuccess事件")
            if (this.gpPageHasLoadedSuccess && this.gpCtaHasLoadedSuccess && this.gpCloseBtnHasLoadedSuccess) {
                console.log("##googleplay各个webview加载成功，准备展示googple页面")
                this.rvTpl.hide()
                this.rvTpl.removeSelf()
                this.gpShowSuccessTimingReport()
                this.slotIn("slot_1", this.gpPage);
                this.slotIn("slot_2", this.gpPageBottom);
                this.slotIn("slot_3", this.endcardCloseBtn);
                this.adShowedData.param.click_scale = window.devicePixelRatio
            } else {
                this.gpShowFailedTimingReport();
                console.log("##googleplay展示失败")
                console.log("##googleplay页面是否加载成功", this.gpPageHasLoadedSuccess)
                console.log("##google下载按钮是否加载成功", this.gpCtaHasLoadedSuccess)
                console.log("##google关闭按钮是否加载成功", this.gpCloseBtnHasLoadedSuccess)
            }
            console.log("##调用endcardshow回调")
            // endcard展示
            this.platform.callReactDeveloper({
                ...App.initData,
                ...this.h5Setting,
                campaign: this.campaign,
                nodeName: "endcardShowSuccess",
                adShowTime: this.adShowTime
            })
            // 调用自动load方法
            this.platform.callLoadAds({
                ...App.initData,
                campaign: this.campaign,
                nodeName: "endcardShowSuccess",
            })
        })
    }

    // 上报相关 - START
    /**
     * onlyImpression 上报
     */
    @report([presetOnlyImpression, presetPvUrls, presetBtShow])
    onlyImpressionTimingReport() {
        console.log('onlyImpression Timing Report')
    }

    @report([presetBtClose])
    adCloseTimingReport() {
        console.log('adClose Timing Report')
    }

    @report([presetBtAdShowFailed])
    adShowFailedTimingReport() {
        console.log('adShowFailed Timing Report')
    }

    @report([presetBtWebviewTerminate])
    webviewTerminateTimingReport() {
        console.log('webviewTerminate Timing Report')
    }

    // GP 页面加载成功
    @report([presetBtGpShowSuccess])
    gpShowSuccessTimingReport() {
        console.log('gpShowSuccess Timing Report')
    }

    // GP 页面加载失败
    @report([presetBtGpShowFailed])
    gpShowFailedTimingReport() {
        console.log('gpShowFailed Timing Report')
    }

    @report([presetBtInitSDKVersionEmpty])
    initSDKVersionEmptyTimingReport() {
        console.log('initSDKVersionEmpty Timing Report')
    }

    // 上报相关 - END

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.rvTpl.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        const promise = Promise.all([
            super._isLoadFinish(),
        ])
        return promise
    }
}